import { Link } from "react-router-dom";
import Tilt from "./Tilt";
import { FREE_PRODUCT_LIMIT, ORDERS_PRO_ONLY, PRO_PRICE, PRO_TRIAL_DAYS } from "../../plans";

const ORDERS_PERK = "Pedidos por WhatsApp desde tu menú";

const plans = [
    {
        name: "Gratis",
        tagline: "Para arrancar",
        price: "$ 0",
        per: "para siempre",
        cta: "Empezar gratis",
        perks: [
            "Catálogo online con tu QR y tu link",
            `Hasta ${FREE_PRODUCT_LIMIT} productos con foto, descripción y precio`,
            "Colores a elección",
            ...(ORDERS_PRO_ONLY ? [] : [ORDERS_PERK]),
            "Lleva la marca “Hecho con MiQRapp”"
        ]
    },
    {
        name: "Pro",
        tagline: "Para tu negocio",
        price: PRO_PRICE,
        per: "/mes",
        note: `${PRO_TRIAL_DAYS} días de prueba gratis`,
        featured: true,
        cta: `Probar Pro ${PRO_TRIAL_DAYS} días gratis`,
        perks: [
            "Todo lo del plan Gratis",
            "Productos ilimitados",
            ...(ORDERS_PRO_ONLY ? [ORDERS_PERK] : []),
            "Sin la marca de MiQRapp",
            "Foto de portada arriba de tu menú",
            "Estadísticas de visitas, pedidos y productos más vistos",
            "Etiquetas (Nuevo, Promo, Sin TACC…) y productos agotados"
        ]
    }
];

const Pricing = () => {
  return (
    <section id="planes" className="lp-pricing">
        <div className="lp-pricing-parallax" data-scroll aria-hidden="true"></div>
        <div className="lp-container lp-pricing-inner">
            <div className="lp-pricing-head" data-reveal>
                <h2>Empezá gratis, pasate a Pro cuando crezcas</h2>
                <p>Precios en pesos, sin permanencia. Pro se cobra todos los meses con Mercado Pago y lo cancelás cuando quieras.</p>
            </div>

            <div className="lp-plans">
                {
                    plans.map((plan, i) => (
                        <div key={plan.name} className={"lp-plan-wrap" + (plan.featured ? " lp-plan-wrap-featured" : "")} data-reveal style={{ "--d": (i * 120) + "ms" }}>
                            {plan.featured && <span className="lp-plan-glow" aria-hidden="true"><i></i></span>}
                            <Tilt className={"lp-plan" + (plan.featured ? " lp-plan-featured" : "")} max={6}>
                                {plan.featured && <span className="lp-plan-ring" aria-hidden="true"><i></i></span>}
                                {plan.featured && <span className="lp-plan-badge">Recomendado</span>}
                                <div className="lp-plan-title">
                                    <h3>{plan.name}</h3>
                                    <span>{plan.tagline}</span>
                                </div>
                                <div className="lp-plan-price">
                                    <strong>{plan.price}</strong>
                                    <span>{plan.per}</span>
                                </div>
                                {plan.note && <span className="lp-plan-note">{plan.note}</span>}
                                <ul>
                                    {
                                        plan.perks.map(perk => (
                                            <li key={perk}>
                                                <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12.5l4.5 4.5L19 7"></path></svg>
                                                {perk}
                                            </li>
                                        ))
                                    }
                                </ul>
                                <Link to="/register" className={"lp-btn " + (plan.featured ? "lp-btn-primary" : "lp-btn-secondary")}>{plan.cta}</Link>
                            </Tilt>
                        </div>
                    ))
                }
            </div>
        </div>
    </section>
  )
}

export default Pricing
